import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	DxButtonModule,
	DxCheckBoxModule,
	DxContextMenuModule,
	DxDataGridModule,
	DxFileUploaderModule, DxFormModule, DxNumberBoxModule,
	DxPivotGridModule,
	DxSelectBoxModule, DxTabPanelModule,
	DxTemplateModule, DxTextBoxModule,
	DxValidatorModule,
} from 'devextreme-angular';

import { ServiceMappingApi, UserApi } from '../api';
import { AzureService } from '../api/azure.service';
import { CoreModule, LoginComponent, LogOutComponent } from '../core';
import { OAuthHandshakeModule } from '../login-callback';
import { PageNotFoundComponent } from '../page-not-found.component';
import { SharedServicesModule } from '../service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DataImportComponent } from './data-import/data-import.component';
import {
	ProductMappingComponent,
	ServiceMappingComponent,
} from './mapping';
import { CategoryMappingComponent } from './mapping/category-mapping/category-mapping.component';
import { CompanyMappingComponent } from './mapping/company-mapping/company-mapping.component';
import { ProcessedSalonCountsComponent } from './mapping/processed-salon-counts/processed-salon-counts.component';
import { RenamePopupsModule } from './mapping/product-mapping/rename-popups/rename-popups.module';
import { TransactionDetailComponent } from './mapping/product-mapping/transaction-detail/transaction-detail.component';
import { UserManagementComponent, UsersFacade } from './user-management';
import { UtilityRoutingModule } from './utility-routing.module';
import { UtilityComponent } from './utility.component';
import { DragulaModule } from 'ng2-dragula';
import { ProductEditComponent } from './mapping/product-mapping/product-edit/product-edit.component';
import { FilterBuilderService } from '../service/filter-builder.service';
import { SalonTypeMappingComponent } from './mapping/salon-type-mapping/salon-type-mapping.component';
import {
	BarcodeGlobalCompanyPrefixComponent
} from './mapping/barcode-mapping/global-company-prefix/global-company-prefix.component';
import {
	BarcodeGlobalCompanyPrefixEditComponent
} from './mapping/barcode-mapping/global-company-prefix/global-company-prefix-edit/barcode-global-company-prefix-edit.component';
import {
	ServiceAndProductMappingCountComponent
} from './mapping/service-and-product-mapping-count/service-and-product-mapping-count.component';
import { CountryMappingComponent } from './mapping/country-mapping/country-mapping.component';
import {
  CountrySubdivisionMappingComponent
} from './mapping/country-subdivision-mapping/country-subdivision-mapping.component';
import {
  SalonChainMappingEditComponent
} from './mapping/salon-chain-mapping/salon-chain-mapping-edit/salon-chain-mapping-edit.component';
import {SalonChainMappingComponent} from './mapping/salon-chain-mapping/salon-chain-mapping.component';
import {PostalCodeMappingComponent} from './mapping/postal-code-mapping/postal-code-mapping.component';
import {QuarterMasterMappingComponent} from './mapping/quarter-master-mapping/quarter-master-mapping.component';
import {ProductBarcodeComponent} from './mapping/product-barcode-mapping/product-barcode.component';
import {
  BarcodeToProductMappingComponent
} from './mapping/barcode-to-product-mapping/barcode-to-product-mapping.component';
import {ProductMasterDataGridComponent} from './mapping/product-master-data-grid/product-master-data-grid.component';
import {ProductBarcodeDetailViewComponent} from './mapping/product-barcode-mapping/detail-view/product-barcode-detail-view.component';
import {BarcodeDetailViewComponent} from './mapping/barcode-to-product-mapping/detail-view/barcode-detail-view.component';
import {PostalCodeDetailViewComponent} from './mapping/postal-code-mapping/detail-view/postal-code-detail-view.component';
import { SalonMappingComponent } from './mapping/salon-mapping/salon-mapping.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
		CoreModule,
		OAuthHandshakeModule,
		SharedServicesModule,
		UtilityRoutingModule,
		DxFileUploaderModule,
		DxSelectBoxModule,
		DxPivotGridModule,
		DxDataGridModule,
		DxTemplateModule,
		DxButtonModule,
		DxCheckBoxModule,
		DxContextMenuModule,
		DxValidatorModule,
		BrowserAnimationsModule,
		RenamePopupsModule,
		DragulaModule.forRoot (),
		DxTextBoxModule,
		DxNumberBoxModule,
		DxTabPanelModule,
		DxFormModule,
	],
	declarations: [
		DataImportComponent,
		DashboardComponent,
		UtilityComponent,
		UserManagementComponent,
		ServiceMappingComponent,
		ProductMappingComponent,
		ProductEditComponent,
		CategoryMappingComponent,
		ProductBarcodeComponent,
		BarcodeToProductMappingComponent,
		CompanyMappingComponent,
		CountryMappingComponent,
		LoginComponent,
		LogOutComponent,
		PageNotFoundComponent,
		TransactionDetailComponent,
		ProductBarcodeDetailViewComponent,
		BarcodeDetailViewComponent,
		PostalCodeDetailViewComponent,
		ProcessedSalonCountsComponent,
		SalonTypeMappingComponent,
		BarcodeGlobalCompanyPrefixComponent,
		BarcodeGlobalCompanyPrefixEditComponent,
		ServiceAndProductMappingCountComponent,
		CountrySubdivisionMappingComponent,
		SalonChainMappingComponent,
		SalonChainMappingEditComponent,
		PostalCodeMappingComponent,
		QuarterMasterMappingComponent,
		ProductMasterDataGridComponent,
		SalonMappingComponent,
	],
  exports: [
		UtilityRoutingModule,
		DataImportComponent,
		UtilityComponent,
		ProductMappingComponent,
		ProductEditComponent,
		LogOutComponent,
		PageNotFoundComponent,
		TransactionDetailComponent,
	  ProductBarcodeDetailViewComponent,
	  BarcodeDetailViewComponent,
	  PostalCodeDetailViewComponent,
		SalonTypeMappingComponent,
		BarcodeGlobalCompanyPrefixComponent,
		BarcodeGlobalCompanyPrefixEditComponent,
		ServiceAndProductMappingCountComponent,
		SalonChainMappingComponent,
		SalonChainMappingEditComponent,
	  ProductBarcodeComponent,
  ],
  providers: [
		{ provide: UserApi, useClass: UserApi },
		{ provide: UsersFacade, useClass: UsersFacade },
		{ provide: ServiceMappingApi, useClass: ServiceMappingApi },
		{ provide: AzureService, useClass: AzureService },
	  NgbActiveModal,
		DatePipe,
		FilterBuilderService
  ],
})
export class UtilityModule { }
